import * as Yup from 'yup';
import { DroneProfile } from '../models/DroneProfile/DroneProfile.model';


const CampaignSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('general_errors.required')),
    description: Yup.string().required(t('general_errors.required')),
    drone: Yup.mixed<DroneProfile>().required(t('general_errors.required')),
    status: Yup.number().required(t('general_errors.required')),
    enable_vantis_send: Yup.boolean().required(t('general_errors.required')),
  });

export default CampaignSchema;
